<app-breadcrumbs class="mb-3" [lastLabel]="(name ?? '')"></app-breadcrumbs>

<mat-card class="mat-elevation-z8 container-card">
    <mat-card-content class="mat-elevation-z8">

        <mat-tab-group (selectedTabChange)="onTabChanged($event)">
            <!-- TAB: DATI GENERALI -->
            <mat-tab label="Dati Generali">
                <div class="kv-list px-4 bg-white">

                    <div class="kv-row" *ngFor="let data of dataGeneral">
                        <div class="kv-label">{{ getLabel(data[0]) }}</div>

                        <div class="kv-value">
                            <!-- URL -->
                            <ng-container *ngIf="isUrlKey(data[0]); else notUrl">
                                <a class="url" [href]="data[1]" target="_blank" rel="noopener">{{ data[1] }}</a>
                            </ng-container>

                            <!-- NON URL -->
                            <ng-template #notUrl>
                                <!-- Lang come chip -->
                                <mat-chip *ngIf="data[0] === 'lang'; else defaultValue" class="lang-chip" color="primary" selected>
                                    {{ data[1] | uppercase }}
                                </mat-chip>

                                <!-- Default -->
                                <ng-template #defaultValue>
                                    <span [class.mono]="data[0] === 'pageRank'">{{ data[1] }}</span>
                                </ng-template>
                            </ng-template>
                        </div>
                    </div>

                </div>
            </mat-tab>

            <!-- TAB: COPIA CACHE -->
            <mat-tab label="Copia Cache">
                <div class="kv-list px-4 bg-white">
                    <div class="kv-row" *ngFor="let data of copiaCache">
                        <div class="kv-label">{{ getLabel(data[0]) }}</div>
                        <div class="kv-value">
                            <div class="prelike" [class.clamped]="!isExpanded(data[0])">
                                {{ data[1] }}
                            </div>
                            <button mat-button type="button" class="toggle" (click)="toggleExpand(data[0])">
                                {{ isExpanded(data[0]) ? 'Mostra meno' : 'Mostra tutto' }}
                            </button>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <!-- TAB: METADATI -->
            <mat-tab label="Mostra Informazioni Metadati">
                <div class="kv-list px-4 bg-white">
                    <div class="kv-row" *ngFor="let data of infoMetadata">
                        <div class="kv-label">{{ getLabel(data[0]) }}</div>
                        <div class="kv-value">
                            <ng-container *ngIf="isUrlKey(data[0]); else plainMeta">
                                <a class="url" [href]="data[1]" target="_blank" rel="noopener">{{ data[1] }}</a>
                            </ng-container>
                            <ng-template #plainMeta>
                                <span class="break">{{ data[1] }}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

    </mat-card-content>
</mat-card>